import React from 'react'
import MusicStreamingFirstSection from './MusicStreamingFirstSection'
import MusicStreamingSecondSection from './MusicStreamingSecondSection'

function MusicStreaming() {
    return (
        <div>
            <MusicStreamingFirstSection />
            <MusicStreamingSecondSection />

        </div>
    )
}

export default MusicStreaming
